<nav class="cabecera">
    <h5>Error 404</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<h2>Page not found</h2>
